<div class="contains-button">
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['input-new-password__boundary']['width']" [height]="class['input-new-password__boundary']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
            <!-- Thông số cơ bản -->
            <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
              <div class="item-basic mb-2">
                <span style="line-height: 1.5;">{{'bat_buoc' | translate}} <br> <span style="font-size:12px">({{'them_vao_khi_dang_ky' | translate}})</span></span>
                <nz-switch [(ngModel)]="config.required"
                   (blur)="updateConfig()"></nz-switch>
              </div>
              <p>{{ "chon_kieu_hien_thi_placeholder" | translate }}</p>
              <nz-radio-group
                [(ngModel)]="staticdata.type_display_placeholder"
                (ngModelChange)="updateStaticData()"
                nzButtonStyle="solid"
                class="mb-2"
              >
                <label class="mb-2" nz-radio [nzValue]="undefined">{{
                  "mac_dinh" | translate
                }}</label>
                <label class="mb-2" nz-radio [nzValue]="'float'">{{
                  "placeholder_truot_len" | translate
                }}</label>
              </nz-radio-group>
              
              <div class="config-text" style="width: 100%">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'chu_nen' | translate}}</mat-label>
                  <textarea 
                    matInput 
                    [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component" 
                    (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event" 
                    (blur)="updateContent('input_text_placeholder')"
                  >
                  </textarea>
                </mat-form-field>
              </div>
      
              <!-- màu chữ nền -->
              <div class="color-pick mb-2">
                <span class="title w-50">{{'mau_chu_nen' | translate}}</span>
                <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary-placeholder']['color']"
                  [style.background]="class['input-new-password__boundary-placeholder']['color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'"
                />
              </div>

              <!-- màu nền chữ nền -->
              <div class="color-pick mb-2">
                <span class="title w-50">{{'mau_nen_chu_nen' | translate}}</span>
                <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary-placeholder']['background-color']"
                  [style.background]="class['input-new-password__boundary-placeholder']['background-color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'"
                />
              </div>

              <div>
                <div class="config-name">
                  <p>{{ "khoang_dem_ben_trai" | translate }}</p>
                  <nz-input-number
                    [nzMin]="config.min ?? 0"
                    [nzMax]="config.max ?? 100"
                    [nzStep]="config.step ?? 1"
                    [ngModel]="
                      class['input-new-password__boundary-placeholder']['padding-left']
                        | vhnumber
                    "
                    (ngModelChange)="
                      class['input-new-password__boundary-placeholder']['padding-left'] =
                        $event + 'px'
                    "
                    (nzBlur)="updateClass()"
                  >
                  </nz-input-number>
                </div>
                <nz-slider
                  [nzMin]="config.min ?? 0"
                  [nzMax]="config.max ?? 100"
                  [nzStep]="config.step ?? 1"
                  [ngModel]="
                    class['input-new-password__boundary-placeholder']['padding-left']
                      | vhnumber
                  "
                  (ngModelChange)="
                    class['input-new-password__boundary-placeholder']['padding-left'] =
                      $event + 'px'
                  "
                  (nzOnAfterChange)="updateClass()"
                >
                </nz-slider>
              </div>

              <div>
                <div class="config-name">
                  <p>{{ "khoang_dem_ben_phai" | translate }}</p>
                  <nz-input-number
                    [nzMin]="config.min ?? 0"
                    [nzMax]="config.max ?? 100"
                    [nzStep]="config.step ?? 1"
                    [ngModel]="
                      class['input-new-password__boundary-placeholder']['padding-right']
                        | vhnumber
                    "
                    (ngModelChange)="
                      class['input-new-password__boundary-placeholder']['padding-right'] =
                        $event + 'px'
                    "
                    (nzBlur)="updateClass()"
                  >
                  </nz-input-number>
                </div>
                <nz-slider
                  [nzMin]="config.min ?? 0"
                  [nzMax]="config.max ?? 100"
                  [nzStep]="config.step ?? 1"
                  [ngModel]="
                    class['input-new-password__boundary-placeholder']['padding-right']
                      | vhnumber
                  "
                  (ngModelChange)="
                    class['input-new-password__boundary-placeholder']['padding-right'] =
                      $event + 'px'
                  "
                  (nzOnAfterChange)="updateClass()"
                >
                </nz-slider>
              </div>

              <!-- cấu hình text -->
              <div class="config-font-size mt-2">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field title="Font" style="width: 100%">
                    <mat-label>    {{'kieu_chu' | translate}}
                    </mat-label>
                    <mat-select [(ngModel)]="
                          class['input-new-password__boundary']['font-family']
                        " (ngModelChange)="updateClass()" [(value)]="class['input-new-password__boundary']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field title="Size" style="width: 100%">
                    <mat-label> {{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [ngModel]="
                          class['input-new-password__boundary']['font-size'] | vhnumber
                        " (ngModelChange)="
                          class['input-new-password__boundary']['font-size'] =
                            $event + 'px'
                        "  (blur)="updateClass()"/>
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font" style="margin-bottom: 10px;"> {{'dinh_dang' | translate}}</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                        class['input-new-password__boundary']['font-weight'] == 'bold'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['input-new-password__boundary']['font-weight'] =
                          class['input-new-password__boundary']['font-weight'] == 'bold'
                            ? '500'
                            : 'bold';
                        updateClass()
                      ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['input-new-password__boundary']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['input-new-password__boundary']['font-style'] =
                          class['input-new-password__boundary']['font-style'] == 'normal'
                            ? 'italic'
                            : 'normal';
                        updateClass()
                      ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['input-new-password__boundary']['text-decoration'] ==
                        'underline'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['input-new-password__boundary']['text-decoration'] =
                          class['input-new-password__boundary']['text-decoration'] ==
                          'none'
                            ? 'underline'
                            : 'none';
                        updateClass()
                      ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-line-through" title="Line-through" nz-button [nzType]="
                        class['input-new-password__boundary']['text-decoration'] ==
                        'line-through'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['input-new-password__boundary']['text-decoration'] =
                          class['input-new-password__boundary']['text-decoration'] ==
                          'none'
                            ? 'line-through'
                            : 'none';
                        updateClass()
                      ">
                    <i nz-icon nzType="strikethrough" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                        class['input-new-password__boundary']['text-transform'] ==
                        'uppercase'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['input-new-password__boundary']['text-transform'] =
                          class['input-new-password__boundary']['text-transform'] ==
                          'none'
                            ? 'uppercase'
                            : 'none';
                        updateClass()
                      ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color2" title="Color" [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary']['color']"
                      [style.background]="class['input-new-password__boundary']['color']" (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                      [cpPositionRelativeToArrow]="true"  type="button" />
                  </div>
                </div>
              </div>
              <!-- màu nền -->
              <div class="color-pick">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary']['background-color']"
                  [style.background]="class['input-new-password__boundary']['background-color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'"
                />
              </div>
              <!-- màu nền ô nhập -->
              <div class="color-pick mt-2">
                <span class="title w-50">{{'mau_nen_o_nhap' | translate}}</span>
                <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary--input']['background-color']"
                  [style.background]="class['input-new-password__boundary--input']['background-color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'"
                />
              </div>
            </li>

            <!-- Biểu tượng -->
            <li nz-submenu [nzTitle]="'bieu_tuong' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
              <!-- màu icon -->
              <div class="color-pick mt-2">
                <span class="title w-50">{{'mau_bieu_tuong' | translate}}</span>
                <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['input-new-password__boundary--icon']['color']"
                  [style.background]="class['input-new-password__boundary--icon']['color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'"
                />
              </div>
              <!-- Kích thước -->
              <div class="slide-bar mt-2">
                <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
                <nz-input-number [nzMin]="10" [nzMax]="50" style="width: 40%"
                  [ngModel]="class['input-new-password__boundary--icon']['font-size'] | vhnumber" (nzBlur)="updateClass()"
                  (ngModelChange)="class['input-new-password__boundary--icon']['font-size'] = $event + 'px'"></nz-input-number>
              </div>
              <div class="font-size">
                <nz-slider [nzMin]="10" [nzMax]="50"
                  [ngModel]="class['input-new-password__boundary--icon']['font-size'] | vhnumber"
                  (nzOnAfterChange)="updateClass()"
                  (ngModelChange)="class['input-new-password__boundary--icon']['font-size'] = $event + 'px'"></nz-slider>
              </div>
              <!-- Khoảng cách -->
              <div class="space-middle">
                <div class="slide-bar">
                  <p class="m-0 title">{{'khoang_cach' | translate}}</p>
                  <nz-input-number [ngModel]="class['input-new-password__boundary']['gap'] | vhnumber" (nzBlur)="updateClass()"
                    style="width: 40%" (ngModelChange)="class['input-new-password__boundary']['gap'] = $event + 'px'"></nz-input-number>
                </div>
                <nz-slider [ngModel]="class['input-new-password__boundary']['gap'] | vhnumber" (nzOnAfterChange)="updateClass()"
                  (ngModelChange)="class['input-new-password__boundary']['gap'] = $event + 'px'"></nz-slider>
              </div>
            </li>

      <!-- Khoảng đệm -->
      <li nz-submenu [nzTitle]="'khoang_dem' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <ng-container>
          <li nz-submenu [nzTitle]="'khung_chua' | translate">
            <div class="px-2">
              <app-padding-config
                [objectChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [classPadding]="class['input-new-password__boundary']"
                [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </li>
          <li nz-submenu [nzTitle]="'o_nhap' | translate">
            <div class="px-2">
              <app-padding-config
                [objectChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [classPadding]="class['input-new-password__boundary--input']"
                [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </li>
        </ng-container>  
      </li>

      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config 
            [device]="device"
            [config]="config"
            [class]="class"
            [shadowClass]="class['input-new-password__boundary']"
            [shadowConfig]="config['box-shadow']"
            [objectChoosing]="objectChoosing"
            >
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device"
                            [class]="class" [elementChoosing]="objectChoosing"
                            [borderClass]="class['input-new-password__boundary']"
                            [id_object]="objectChoosing._id"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình thông báo-->
      <li nz-submenu nzTitle="{{'cau_hinh_thong_bao' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="container-font">
            
          <!-- Chọn đa ngôn ngữ -->
          <div class="mb-3">
            
          </div>
          
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'thong_bao_truong_hop_de_trong' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['input_text_error_required_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_error_required' : objectChoosing.component" 
                (ngModelChange)="staticdata['input_text_error_required_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateContent('input_text_error_required')"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['input-new-password__error']"
                    [textWrapperClass]="class['input-new-password__error']"
                    >
          </app-text-format-config>

          <div class="mt-2">
            <div class="config-name">
              <p>{{ "mau_nen" | translate }}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['input-new-password__error']['background-color']"
              [style.background]="class['input-new-password__error']['background-color']"
              (colorPickerClose)="updateClass()"
              [cpWidth]="'230px'" />
            </div>
          </div>

          <div class="mt-2">
            <div class="config-name">
              <p>{{ "chieu_dai_bang_voi_o_nhap" | translate }}</p>
              <nz-switch [ngModel]="class['input-new-password__error']['width'] == '100%'"
              (ngModelChange)="changeWidthOfError($event)">
              </nz-switch>
            </div>
          </div>

          <!-- Khoảng cách bên trên -->
          <div class="mt-2">
            <div class="config-name">
              <p>{{ "khoang_cach_ben_tren" | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['input-new-password__error']['margin-top'] | vhnumber" 
                (ngModelChange)="class['input-new-password__error']['margin-top'] = $event + 'px'" 
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['input-new-password__error']['margin-top'] | vhnumber" 
              (ngModelChange)="class['input-new-password__error']['margin-top'] = $event + 'px'" 
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>

          <!-- Cấu hình khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
            <app-padding-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classPadding]="class['input-new-password__error']"
              [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình hình dạng viền -->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
            <app-borders-config [elementChoosing]="objectChoosing"
            [device]="device" [class]="class"
            [borderClass]="class['input-new-password__error']"
            [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>
          <!-- Cấu hình bo tròn -->
          <li nz-submenu nzTitle="{{'bo_tron' | translate}}">
            <app-borders-radius-config
            [device]="device" [class]="class"
            [borderRadiusClass]="class['input-new-password__error']"
            [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>
          <!-- Cấu hình đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}">
            <app-shadow-config 
                [device]="device"
                [config]="config"
                [class]="class"
                [shadowClass]="class['input-new-password__error']"
                [shadowConfig]="config['error-box-shadow']"
                [objectChoosing]="objectChoosing"
                >
            </app-shadow-config>
          </li>
        </div>
      </li>
      <!-- Cấu hình chóp tam giác thông báo -->
      <li nz-submenu nzTitle="{{'chop_tam_giac_thong_bao' | translate}}" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <div class="config-name">
          <p>{{ "hien_thi" | translate }}</p>
          <nz-switch [ngModel]="config['error_arrow']?.['display'] == 'block'"
          (ngModelChange)="
            config['error_arrow']['display'] = $event ? 'block' : 'none';
            class['input-new-password__error']['overflow'] = $event ? 'visible' : 'hidden';
            updateObject();
          ">
          </nz-switch>
        </div>

        <!-- Cấu hình chi tiết chóp tam giác -->
        <ng-container *ngIf="config['error_arrow']?.['display'] == 'block'">
          <!-- Màu -->
          <div class="mt-2">
            <p>
              {{ "mau" | translate }}
              <i class="bi bi-question-circle ml-2" nz-tooltip [style]="{ fontSize: '16px' }"
              nzTooltipTitle="{{'khi_bat_mau_se_trung_voi_mau_nen_cua_thong_bao_khi_tat_mau_se_tuy_chinh' | translate}}"></i>
            </p>
            <div class="config-name">
              <nz-switch [ngModel]="config['error_arrow']?.['is_same_color']"
              (ngModelChange)="
                config['error_arrow']['is_same_color'] = $event;
                updateConfig();
              ">
              </nz-switch>
              <input *ngIf="!config['error_arrow']?.['is_same_color']"
              class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="config['error_arrow']['border_bottom_color']"
              [style.background]="config['error_arrow']['border_bottom_color']"
              (colorPickerClose)="updateConfig()" [cpWidth]="'230px'" />
            </div>
          </div>

          <!-- Kích thước -->
          <div class="mt-2">
            <div class="config-name">
              <p>
                {{ "kich_thuoc" | translate }}
                <i class="bi bi-question-circle ml-2" nz-tooltip [style]="{ fontSize: '16px' }"
                nzTooltipTitle="{{'day_la_chinh_sua_chieu_dai_va_chieu_cao_se_bang_mot_nua_chieu_dai' | translate}}"></i>
              </p>
              <nz-input-number [nzMin]="0" [nzMax]="40" [nzStep]="1"
                [ngModel]="config['error_arrow']?.['border_width'] | vhnumber" 
                (ngModelChange)="config['error_arrow']['border_width'] = $event + 'px'" 
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="20" [nzStep]="1"
              [ngModel]="config['error_arrow']?.['border_width'] | vhnumber" 
              (ngModelChange)="config['error_arrow']['border_width'] = $event + 'px'" 
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>

          <!-- Vị trí chiều dọc -->
          <div class="mt-2">
            <div class="config-name">
              <p>{{ "vi_tri_chieu_doc" | translate }}</p>
              <nz-input-number [nzMin]="-100" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['error_arrow']?.['top'] | vhnumber" 
                (ngModelChange)="config['error_arrow']['top'] = $event + 'px'" 
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="-100" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['error_arrow']?.['top'] | vhnumber" 
              (ngModelChange)="config['error_arrow']['top'] = $event + 'px'" 
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>

          <!-- Vị trí chiều ngang -->
          <div class="mt-2">
            <div class="config-name">
              <p>{{ "vi_tri_chieu_ngang" | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="90" [nzStep]="1"
                [ngModel]="config['error_arrow']?.['left'] | vhnumber" 
                (ngModelChange)="config['error_arrow']['left'] = $event + '%'" 
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="90" [nzStep]="10"
              [ngModel]="config['error_arrow']?.['left'] | vhnumber" 
              (ngModelChange)="config['error_arrow']['left'] = $event + '%'" 
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['input-new-password']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [effectFileUsing]="'input-new-password'">
        </app-choose-animations-config>
      </li>
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <div class="button-size">
          
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['input-new-password__boundary']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"  [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>

  </div>
</div>
